import { render } from "./DeliveryYandexFood.vue?vue&type=template&id=54f4b191&scoped=true"
import script from "./DeliveryYandexFood.vue?vue&type=script&lang=js"
export * from "./DeliveryYandexFood.vue?vue&type=script&lang=js"

import "./DeliveryYandexFood.vue?vue&type=style&index=0&id=54f4b191&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f4b191"]])

export default __exports__